import styled from 'styled-components';

export const NextUpArrowWrapper = styled.div`
margin-left: 5px;
width: 13px;
transform: ${props => props.isOpen ? 'rotate(180deg)' : ''};
`;